module.exports = __webpack_public_path__ + "assets/0d3f1f09c8946aa465c7b57a22551a0c.png";